const alertDialog = {
    successTitle: 'Успех',
    successText: 'Операция выполнена успешно.',
    failTitle: 'Провал',
    failText: 'Что-то пошло не так во время выполнения операции.',
    ok: 'Ок',
};
const statuses = {
    available: 'Опубликован',
    onModeration: 'На модерации',
    declined: 'Отклонён',
    soldOut: 'Продан',
    unpublished: 'Не опубликован',
    distress: 'Distress',
};
const floorsList = {
    low: 'Низкий',
    medium: 'Средний',
    high: 'Высокий',
    null: '',
};
const paymentMethods = {
    bank_check: 'Чек',
    credit_debit_card: 'Дебетовая/кредитная карта',
    cash: 'Наличные',
    bank_transfer: 'Банковский перевод',
    crypto: 'Crypto',
};
const heightsList = {
    Simplex: 'Симплекс',
    Duplex: 'Дуплекс',
    Triplex: 'Триплекс',
    Quadruplex: 'Квадриплекс',
    'Five Floors': 'Пятиэтажный',
    'Six Floors': 'Шестиэтажный',
    Loft: 'Лофт',
    simplex: 'Симплекс',
    duplex: 'Дуплекс',
    triplex: 'Триплекс',
    quadruplex: 'Квадриплекс',
    'five floors': 'Пятиэтажный',
    'six floors': 'Шестиэтажный',
    loft: 'Лофт',
};
const units = {
    units_one: '{{count}} юнит',
    units_two: '{{count}} юнитa',
    units_few: '{{count}} юнитa',
    units_many: '{{count}} юнитов',
    units_other: '{{count}} юнитов',
};
const projects = {
    projects_one: '{{count}} проект',
    projects_two: '{{count}} проекта',
    projects_few: '{{count}} проекта',
    projects_many: '{{count}} проектов',
    projects_other: '{{count}} проектов',
};
const roles = {
    broker: 'Пользователь',
    head_of_sales_department: 'Администратор',
    admin: 'Супер-администратор',
};
const passwordRecoveryModal = {
    header: 'Восстановление пароля',
    body: 'Введите адрес электронной почты и мы вышлем на него ссылку для восстановления пароля.',
    forgotSubmited: 'Мы отправили вам письмо, перейдите по указанной в нем ссылке, для создания нового пароля.',
    continue: 'Продолжить',
    ok: 'Ok',
};
const changePasswordModal = {
    title: 'Смена пароля',
    uppercaseAndLowercaseLetterTitle: 'Пароль обязательно должен содержать минимум одну строчную и одну заглавную букву.',
    oneDigitTitle: 'Пароль обязательно должен содержать минимум одну цифру.',
    specialSymbolTitle: 'Пароль обязательно должен содержать минимум один специальный символ.',
    minimumLengthTitle: 'Длина пароля обязательно должна быть не менее 8 символов.',
    body: 'Создайте новый пароль. Он должен быть не менее 8 символов и включать хотя бы одну заглавную и строчную букву, цифру и символ.',
    oldPassword: {
        title: 'Текущий пароль',
        placeholder: 'Введите текущий пароль',
    },
    newPassword: {
        title: 'Новый пароль',
        placeholder: 'Введите новый пароль',
    },
    newPasswordConfirm: {
        title: 'Подтверждение пароля',
        placeholder: 'Подтвердите новый пароль',
    },
    forgotButton: 'Я забыл свой пароль',
    passwordSubmited: {
        header: 'Теперь у вас новый пароль!',
        body: 'Новый пароль успешно создан, теперь вы можете  использовать его для входа в Geniemap.',
    },
    continue: 'Продолжить',
    ok: 'Ok',
};
const editImage = {
    title: 'Изменить изображение',
    reset: 'Сбросить',
    apply: 'Применить',
};
const profileForm = {
    generalSubheader: 'Основная информация',
    name: 'Имя Фамилия',
    emailTooltip: 'Если вы хотите обновить почту, пожалуйста, свяжитесь с вашим администратором.',
    phone: 'Номер телефона',
    socialSubheader: 'Социальные сети',
    socialNetworksTooltip: 'Необязательные поля. Они отобразятся как дополнительные контакты в вашем каталоге.',
};
const catalogSettingsModal = {
    title: 'Персонализация каталога',
    titleMobile: 'Настройки каталога',
    tab1: 'Общие',
    tab2: 'Дополнительные слайды',
    themeColor: 'Цвет темы',
    language: 'Язык',
    measures: 'Единицы измерения',
    currency: 'Валюта',
    additionalCurrency: 'Дополнительная валюта',
    additionalCurrencyHint: 'Отображает цены в\nдвух разных валютах.',
    noAdditionalCurrency: 'Без дополнительной валюты',
    socialNetworks: 'Отображать мои социальные сети',
    unitsWithLayouts: 'Юниты с планами',
    hideUnitsNumbers: 'Скрыть номера юнитов',
    fullUnitsList: 'Полный список юнитов',
    areaSlide: 'Локация проекта',
    hideDeveloper: 'Скрыть застройщика',
    hideDeveloperHint: 'Удаляет упоминание застройщика из названия проекта и его описания.',
    developerSlide: 'Описание застройщика',
    customSlide: 'Пользовательский слайд',
    customSlideTitle: 'Заголовок слайда',
    customSlideText: 'Текст слайда',
    customSlideHint: 'Отображается в\nконце каталога.\nНа слайд\nможно добавить \nизображение\nи текст.',
    requiredField: 'Поле обязательно для заполнения',
    reset: 'Сбросить',
    resetMobile: 'Сброс',
    save: 'Сохранить',
    selectImage: 'Выбрать изображение',
};
const filters = {
    title: 'Фильтры',
    clear: 'Очистить',
    reset: 'Сбросить',
    tabs: {
        location: {
            title: 'Локация',
            search: 'Поиск местоположения',
            region: {
                AE: 'Эмират',
                default: 'Регион',
            },
            regionNoData: {
                AE: 'Нет эмиратов подходящих поиску',
                default: 'Нет регионов подходящих поиску',
            },
            districts: 'Район',
            districtsNoData: 'Нет районов в данных эмиратах',
            districtsRegionsNoData: 'Нет районов в данных регионах',
        },
        company: {
            title: 'Компания',
            search: 'Поиск компании',
            noResultsFound: 'Результат не найден',
            tryDifferentSearchOptions: 'Попробуйте использовать другие поисковые опции',
            addToFavoriteError: 'Ошибка добавления в избранное',
            favourites: 'Избранные компании',
            tabs: {
                all: 'Все',
                developers: 'Застройщики',
                agencies: 'Компании',
            },
        },
        moreFilters: {
            title: 'Основные фильтры',
            statisticsTitle: 'Доп. фильтры',
            showMe: {
                title: 'Дополнительные фильтры',
                favourites: 'Избранное',
                preLaunch: 'Предзапуск',
                soldOut: 'Продано',
                myAgencyUnits: 'Юниты моего агентства',
                developerStock: 'Наличие от застройщика',
                resale: 'Перепродажа',
                distress: 'Дистресс',
            },
            availability: {
                title: 'Статус проекта',
            },
            handover: {
                title: 'Готовность проекта',
                from: 'Сдача от',
                to: 'Сдача до',
                offPlan: 'Вне плана',
                ready: 'Готовый',
                year: 'Год',
                quarter: 'Квартал',
                unselected: 'Не выбрано',
                preset_one: '<{{count}} год',
                preset_two: '<{{count}} года',
                preset_few: '<{{count}} лет',
                preset_many: '<{{count}} лет',
                preset_other: '<{{count}} лет',
            },
            price: {
                title: 'Цена',
                from: 'От',
                to: 'До',
            },
            pricePerSquare: {
                title: 'Цена за {{squareMeasurement}}',
                from: 'От',
                to: 'До',
            },
            size: {
                title: 'Площадь',
                from: 'От',
                to: 'До',
            },
            height: {
                title: 'Этажность юнита',
            },
            ownershipType: {
                title: 'Тип собственности',
                allTypes: 'Все типы',
                leasehold: 'Арендное владение',
                freehold: 'Полная собственность',
            },
            layout: {
                title: 'Количество спален',
            },
            unitType: {
                title: 'Тип недвижимости',
            },
            furnishing: {
                title: 'Отделка',
            },
            unitFeatures: {
                title: 'Особенности юнита',
            },
            serviceCharge: {
                title: {
                    TH: 'Обслуживание',
                    default: 'Обслуживание',
                },
                from: 'От',
                to: 'До',
            },
            paymentPlans: {
                title: 'План оплаты',
                subtitle: 'Первоначальный взнос',
                secondSubtitle: 'Первоначальный взнос в {{currency}}',
                from: 'От',
                to: 'До',
                postHandover: 'Постоплата',
            },
            forAdmins: {
                title: 'Для администраторов',
                allUnits: 'Все юниты',
                unitsWithLayouts: 'Только юниты с планировками',
                unitsWithoutLayouts: 'Только юниты без планировок',
            },
            hints: {
                favorite: 'Проекты, которые вы добавили в избранное',
                ourUnits: 'Resale юниты в продаже от вашей компании',
                serviceCharge: 'Ежегодная плата за обслуживание',
                postHandover: 'Есть платежи после сдачи объекта.',
            },
        },
    },
};
const measures = {
    language: 'Язык',
    russianLanguage: 'Русский',
    englishLanguage: 'Английский',
    arabicLanguage: 'Арабский',
    currency: 'Валюта',
    measures: 'Единица измерения',
};
const countries = {
    modalTitle: 'Страны',
    planTitle: '{{available}}/{{total}} стран',
    planSubtitle: 'Доступно в вашем тарифе.',
    planHint: 'Свяжитесь с менеджером для расширения доступа',
    subtitles: {
        projects1000: '1000+ проектов',
        projects500: '500+ проектов',
        projectsCount: '{{count}}+ проектов',
        noProjectsYet: 'Пока нет проектов',
        readyToConnect: 'Готово к подключению',
        comingSoon: 'Скоро',
    },
    footer: 'Откройте для себя недвижимость по всему миру →',
    changeCountryError: {
        title: 'Не удалось сменить страну',
        description: 'Попробуйте ещё раз позже',
    },
};
const login = {
    welcome: 'Добро пожаловать 👋',
    description: 'Начни отслеживать лучшие предложения недвижимости в OAЭ',
    email: 'Почта',
    password: 'Пароль',
    login: 'Войти',
    forgotPassword: 'Забыли пароль?',
    registrationRequest: 'Заявка на регистрацию',
    passwordRecovery: {
        header: 'Восстановление пароля',
        body: 'Введите адрес электронной почты и мы вышлем на него ссылку для восстановления пароля.',
        forgotSubmited: 'Мы отправили вам письмо, перейдите по указанной в нем ссылке, для создания нового пароля.',
    },
    continue: 'Продолжить',
    ok: 'Ок',
};
const autocomplete = {
    searchPlaceholder: 'Поиск',
    noMatch: 'Нет совпадений',
};
const noSelected = 'Не выбран';
export { alertDialog, statuses, floorsList, paymentMethods, heightsList, units, projects, roles, passwordRecoveryModal, changePasswordModal, editImage, profileForm, catalogSettingsModal, filters, measures, countries, login, autocomplete, noSelected, };
